<script>
import FormModel from "@/views/Request/Claim/Components/FormModel.vue";

export default {
    name: "ClaimForm",
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        deleteAction: Boolean,
        viewAction: Boolean,
    },
    components: {FormModel}
}
</script>

<template>
    <form-model
        type="CLAIM"
        :view-action="viewAction"
        :delete-action="deleteAction"
        :add-action="addAction"
        :update-action="updateAction"
    />
</template>